// extracted by mini-css-extract-plugin
module.exports = {"empty-cart-wrapper":"CartEmptyText-style_empty-cart-wrapper__14Odb"};